import axios from "@/utils/axios"


interface IObj {
    [key: string]: any
}
interface IResponse { status: boolean; data?: any; message?: string; error?: string }

export const updateOrderSummary = async (doc?: {items:IObj[]}):Promise<IResponse> => {
    try {
        const result = await axios.post(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/order-summary/update`, doc);
        if (result?.data?.status) {
            return { status: true, message: result?.data?.message, data: result?.data?.data };
        } else {
            return { status: false, message: result?.data?.message || "Failed to update order summary", data: result?.data?.data }
        }
    } catch (error: any) {
        return { status: false, message: error.message }
    }
};
export const fetchOrderSummaryDetails = async ():Promise<IResponse> => {
    try {
        const result = await axios.get(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/order-summary/details`);
        if (result?.data?.status) {
            return { status: true, message: result?.data?.message, data: result?.data?.data };
        } else {
            return { status: false, message: result?.data?.message || "Failed to update order summary" }
        }
    } catch (error: any) {
        return { status: false, message: error.message }
    }
};

export const createOrder = async (orderData: IObj):Promise<IResponse> => {
    try {
        const result = await axios.post(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/preorder/create`, orderData);
        if (result?.data?.status) {
            return { status: true, message: result?.data?.message, data: result?.data?.data };
        } else {
            return { status: false, message: result?.data?.message || "Failed to create order",data: result?.data?.data }
        }
    } catch (error: any) {
        return { status: false, message: error.message }
    }
};
export const fetchOrderPaymentDetails = async (sign: string):Promise<IResponse> => {
    try {
        const result = await axios.get(`${process.env.NEXT_PUBLIC_PAYMENT_SERVICE}/payment-orders/details?sign=${sign}`);
        if (result?.data?.status) {
            return { status: true, message: result?.data?.message, data: result?.data?.data };
        } else {
            return { status: false, message: result?.data?.message || "Failed to fetch order payment details",data:result?.data?.data  }
        }
    } catch (error: any) {
        return { status: false, message: error.message }
    }
};
export const placeCodOrder = async (sign: string):Promise<IResponse> => {
    try {
        const result = await axios.post(`${process.env.NEXT_PUBLIC_PAYMENT_SERVICE}/payment-orders/place-cod`, { sign });
        if (result?.data?.status) {
            return { status: true, message: result?.data?.message, data: result?.data?.data };
        } else {
            return { status: false, message: result?.data?.message || "Failed to fetch order payment details",data:result?.data?.data  }
        }
    } catch (error: any) {
        return { status: false, message: error.message }
    }
};
export const fetchOrderStatus = async(sign:string):Promise<IResponse> => {
    try {
        const result = await axios.get(`${process.env.NEXT_PUBLIC_PAYMENT_SERVICE}/payment-orders/status?sign=${sign}`);
        if (result?.data?.status) {
            return { status: true, message: result?.data?.message, data: result?.data?.data };
        } else {
            return { status: false, message: result?.data?.message || "Failed to fetch order status",data:result?.data?.data  }
        }
    } catch (error: any) {
        return { status: false, message: error.message }
    }
}